import { render } from "./ConfigurationWindchillInitial.vue?vue&type=template&id=7bcc64cb"
import script from "./ConfigurationWindchillInitial.vue?vue&type=script&lang=js"
export * from "./ConfigurationWindchillInitial.vue?vue&type=script&lang=js"

import "./ConfigurationWindchillInitial.vue?vue&type=style&index=0&id=7bcc64cb&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__